import { useQuery } from "react-query";
import { api } from "utils/api";
import type { ArtistReview, ProjectReview } from "../types";

// TODO - Data comes back with pagination - Allow Pagination
type ReviewResponse = {
  data: (ArtistReview | ProjectReview)[];
  searchAfter?: string;
  notModeratedTotal?: number;
  notModeratedAvailable?: number;
};

const getPendingReviews = () =>
  api.get<ReviewResponse>(`/moderator/reviews`, { requireAuth: true });

const usePendingReviews = () =>
  useQuery(["reviews", "pending"], () => getPendingReviews(), {
    refetchOnWindowFocus: false,
  });

export { usePendingReviews };
